import { createContext } from "react";
import { ISendReportButtonProps } from "../interfaces";

export interface IReportExpandedRowContext {
    setSendButtonProps: (props: ISendReportButtonProps) => any,
}

export const ReportExpandedRowContext = createContext<IReportExpandedRowContext>({} as IReportExpandedRowContext);